
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 96.227 96.227"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M73.099 15.973l-9.058.004c-7.102 0-8.477 3.375-8.477 8.328v10.921h16.938l-.006 17.106H55.564v43.895H37.897V52.332h-14.77V35.226h14.77V22.612C37.897 7.972 46.84 0 59.9 0l13.2.021-.001 15.952z","fill":"#FFF"}})])
          )
        }
      }
    